import _parseInt from "lodash/parseInt";
import { HTMLContent, RadioList } from '@datacamp/le-shared-components';
import { Button } from '@datacamp/waffles/button';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setChoice } from '../actions/actionCreators/setChoice';
import blur from '../lib/blur';
import selectCurrentChoice from '../selectors/selectCurrentChoice';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const MultipleChoice = _ref => {
  let {
    checkExercise,
    customQuestion,
    exerciseId,
    solutionItems
  } = _ref;
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const currentChoice = useSelector(state => selectCurrentChoice(state, exerciseId));
  const setCurrentChoice = React.useCallback(choiceValue => {
    dispatch(
    // We rely that `choiceValue` is the index
    // TODO: formalize possible_answers to also have a key associated to the value
    setChoice({
      currentChoice: _parseInt(choiceValue, 10),
      exerciseId
    }));
  }, [dispatch, exerciseId]);
  const correctChoice = solutionItems.findIndex(item => item.correct);
  const submitChoice = React.useCallback(() => {
    blur();
    if (currentChoice === undefined) {
      return;
    }
    const isCorrect = currentChoice === correctChoice;
    checkExercise(solutionItems[currentChoice].feedback, isCorrect, "selected_option = ".concat(currentChoice + 1));
  }, [checkExercise, correctChoice, currentChoice, solutionItems]);
  const question = customQuestion != null ? customQuestion : t('MultipleChoice.heading');
  return ___EmotionJSX("div", {
    className: "dc-panel__body"
  }, ___EmotionJSX("h4", null, question), ___EmotionJSX(RadioList, {
    name: "exercise=".concat(exerciseId),
    onChange: setCurrentChoice,
    value: currentChoice === undefined ? '' : currentChoice.toString()
  }, solutionItems.map((value, index) => ___EmotionJSX(RadioList.Item, {
    key: "key-".concat(index),
    value: index.toString()
  }, ___EmotionJSX(HTMLContent, {
    html: value.answer
  })))), ___EmotionJSX("div", {
    className: "dc-edge-to-edge"
  }, ___EmotionJSX("div", {
    className: "dc-edge-to-edge__item"
  }), ___EmotionJSX("div", {
    className: "dc-edge-to-edge__item"
  }, ___EmotionJSX(Button, {
    "data-cy": "submit-button",
    disabled: currentChoice === undefined,
    onClick: submitChoice // TODO: have a loading flag for ChatGPT?
    ,
    size: "small",
    variant: "primary"
  }, t('MultipleChoice.button')))));
};